export default "__VITE_ASSET__dfbe6c48__"